import { Controller } from "@hotwired/stimulus"

// Toggles the new-monograph form between its species (Herb) and genus pickers.
// Both share the monograph[subject_id] name, so the hidden panel's fields are
// disabled — a disabled control isn't submitted, leaving exactly one subject_id
// to post. Driven by the subject_type radios.
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    // Defer the first toggle to the next frame: the panels' TomSelect pickers
    // initialise (on connect) while their panels are still visible, so each
    // measures a real width. TomSelect renders a broken, zero-width control if
    // it boots inside a display:none element, so hiding must happen after.
    requestAnimationFrame(() => this.update())
  }

  update() {
    const chosen = this.element.querySelector(
      "input[name='monograph[subject_type]']:checked"
    )?.value

    this.panelTargets.forEach((panel) => {
      const active = panel.dataset.kind === chosen
      panel.hidden = !active
      panel.querySelectorAll("select, input").forEach((field) => {
        field.disabled = !active
      })
    })
  }
}
